<app-modal-container
  [title]="isBulkMode ? ('durationModal.bulkTitle' | translate) : ''"
  (dismissModal)="closeModal()"
  [showFooter]="true"
  data-testid="planning-duration-modal"
>
  <div body>
    <form [formGroup]="form">
      <div class="list-mode-wrapper">

        <!-- ── Bannière mode masse ───────────────────────────────────────── -->
        @if (isBulkMode) {
        <div class="alert alert-info py-2 px-3 mb-3 d-flex align-items-center gap-2">
          <i class="bi bi-info-circle-fill"></i>
          <span class="small">{{ 'durationModal.bulkBanner' | translate }}</span>
        </div>
        }

        <!-- ── Date + Durée ─────────────────────────────────────────────── -->
        <div class="list-mode-card">
          <h6 class="list-section-title">
            Date de réalisation & temps passé
          </h6>
          <div class="pill-grid">
            <div class="pill-field">
              <div class="pill-input">
                <i
                  class="bi bi-calendar3 pill-icon"
                  tabindex="0"
                  role="button"
                  (click)="toggleDatePicker(ddList)"
                  (keydown.enter)="toggleDatePicker(ddList)"
                  (keydown.space)="toggleDatePicker(ddList)"
                ></i>
                <input
                  class="pill-control"
                  formControlName="plannedDate"
                  ngbDatepicker
                  #ddList="ngbDatepicker"
                  [disabled]="!isBulkMode && isCurrentStatusNotApplicable()"
                />
              </div>
              @if(!isBulkMode && submitted && formControls.plannedDate.errors){
              <div class="invalid-feedback d-block">
                {{ "durationModal.requierd" | translate }}
              </div>
              }
            </div>
            <div class="pill-field">
              <div class="pill-input">
                <i
                  class="bi bi-clock pill-icon"
                  tabindex="0"
                  role="button"
                  (click)="focusDurationInput(durationInput)"
                  (keydown.enter)="focusDurationInput(durationInput)"
                  (keydown.space)="focusDurationInput(durationInput)"
                ></i>
                <input
                  type="text"
                inputmode="decimal"
                  class="pill-control"
                  formControlName="duration"
                  placeholder="0,00 / HH:MM"
                  #durationInput
                  [disabled]="!isBulkMode && isCurrentStatusNotApplicable()"
                />
                <span class="pill-suffix">heure(s)</span>
              </div>
              @if(!isBulkMode && submitted && formControls.duration.errors){
              <div class="invalid-feedback d-block">
                {{ "durationModal.requierd" | translate }}
              </div>
              }
            </div>
          </div>
        </div>

        <!-- ── Description ──────────────────────────────────────────────── -->
        <div class="list-collapse">
          <button
            type="button"
            class="collapse-toggle"
            (click)="toggleDescription()"
            [disabled]="!isBulkMode && isCurrentStatusNotApplicable()"
            data-testid="planning-duration-modal-description-toggle"
          >
            <span>Description de la tâche</span>
            <i
              class="bi"
              [ngClass]="{
                'bi-chevron-up': isDescriptionExpanded,
                'bi-chevron-down': !isDescriptionExpanded
              }"
            ></i>
          </button>
          @if (isDescriptionExpanded) {
          <div class="collapse-body" data-testid="planning-duration-modal-description-body">
            <textarea
              class="form-control"
              formControlName="description"
              [placeholder]="'durationModal.taskDescriptionPlaceholder' | translate"
              rows="4"
              [disabled]="!isBulkMode && isCurrentStatusNotApplicable()"
              data-testid="planning-duration-modal-description-textarea"
            ></textarea>
          </div>
          }
        </div>

        <!-- ── Progression + Erreurs (mode masse uniquement) ────────────── -->
        @if (isBulkMode) {

          @if (isFetchingIds) {
          <div class="d-flex align-items-center gap-2 py-2">
            <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            <span class="small text-muted">{{ 'durationModal.bulkFetchingIds' | translate }}</span>
          </div>
          }

          @if (bulkErrors.length > 0) {
          <div class="alert alert-danger alert-sm py-2 px-3 mb-2">
            <i class="bi bi-exclamation-triangle-fill me-1"></i>
            <span class="small">{{ bulkErrors[0] }}</span>
          </div>
          }
        }

        <!-- ── Statuts ───────────────────────────────────────────────────── -->
        <div class="list-status-section">
          <h6 class="list-section-title">{{ "durationModal.status" | translate }}</h6>
          <div class="status-options">
            @for (status of getAllStatusesInOrder(); track status.id || status.code) {
              @if (status.isStandardButton && status.standardButtonCode) {
                @if (getStandardButtonForCode(status.standardButtonCode); as button) {
                  <button
                    type="button"
                    class="status-option"
                    (click)="handleStandardStatus(button)"
                    [disabled]="
                      isBulkProcessing || isFetchingIds || isBulkCommentPosting ||
                      (!isBulkMode && (
                        isSaving ||
                        (isCurrentStatusNotApplicable() && button.code !== 'NOT_APPLICABLE') ||
                        (isCurrentStatusDone() && button.code !== 'NOT_APPLICABLE')
                      ))
                    "
                  >
                    @if (isBulkProcessing && currentBulkActionCode === (button.submitStatus ?? 'NOT_APPLICABLE')) {
                    <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                    }
                    {{ getStandardButtonLabel(button) }}
                  </button>
                }
              } @else {
                <button
                  type="button"
                  class="status-option"
                  (click)="onSubmit(status.code)"
                  [disabled]="
                    isBulkProcessing || isFetchingIds || isBulkCommentPosting ||
                    (!isBulkMode && (
                      isSaving ||
                      isCurrentStatusNotApplicable() ||
                      (isCurrentStatusDone() && status.code !== 'NOT_APPLICABLE')
                    ))
                  "
                >
                  @if (isBulkProcessing && currentBulkActionCode === status.code) {
                  <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                  }
                  {{ status.name }}
                </button>
              }
            }
          </div>
        </div>

        <!-- ── Commentaires ──────────────────────────────────────────────── -->
        <div class="list-collapse">
          <button
            type="button"
            class="collapse-toggle"
            (click)="isBulkMode ? (isBulkCommentExpanded = !isBulkCommentExpanded) : toggleComments()"
            [disabled]="
              isBulkProcessing || isFetchingIds ||
              (!isBulkMode && isCurrentStatusNotApplicable())
            "
            data-testid="planning-duration-modal-comments-toggle"
          >
            <span>Commentaires</span>
            <i
              class="bi"
              [ngClass]="{
                'bi-chevron-up': isBulkMode ? isBulkCommentExpanded : isCommentsExpanded,
                'bi-chevron-down': isBulkMode ? !isBulkCommentExpanded : !isCommentsExpanded
              }"
            ></i>
          </button>

          @if (!isBulkMode && isCommentsExpanded) {
          <!-- Mode normal : composant commentaire complet -->
          <div class="collapse-body" data-testid="planning-duration-modal-comments-body">
            @if (calendarEvent) {
              @for (comment of calendarEvent.comments ?? []; track comment.id) { <p><strong>{{ comment.author }}</strong> {{ comment.body }}</p> }
              <textarea class="form-control" [(ngModel)]="calendarComment" [ngModelOptions]="{standalone:true}" maxlength="5000" [attr.aria-label]="'planning.visual.comment' | translate"></textarea>
            } @else {
            <app-comment-field
              [ownerId]="task.id"
              [ownerCommentClass]="'ACTIVITY'"
              [ownerClass]="'TASK'"
              (commentAdded)="onCommentAdded()"
              data-testid="planning-duration-modal-comment-field"
            >
            </app-comment-field>
            }
          </div>
          }

          @if (isBulkMode && isBulkCommentExpanded) {
          <!-- Mode masse : textarea simple -->
          <div class="collapse-body">

            @if (bulkCommentErrors.length > 0) {
            <div class="alert alert-danger alert-sm py-2 px-3 mb-2">
              <i class="bi bi-exclamation-triangle-fill me-1"></i>
              <span class="small">{{ bulkCommentErrors[0] }}</span>
            </div>
            }

            <textarea
              class="form-control form-control-sm mb-2"
              [(ngModel)]="bulkCommentText"
              [ngModelOptions]="{ standalone: true }"
              rows="3"
              [placeholder]="'durationModal.bulkCommentPlaceholder' | translate"
              [disabled]="isBulkCommentPosting || isFetchingIds"
            ></textarea>
            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                (click)="executeBulkComment()"
                [disabled]="!bulkCommentText.trim() || isBulkCommentPosting || isFetchingIds || isBulkProcessing"
              >
                @if (isBulkCommentPosting) {
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                }
                {{ 'durationModal.bulkCommentSubmit' | translate }}
              </button>
            </div>
          </div>
          }
        </div>

      </div>
    </form>
  </div>

  <div footer>
    <div class="d-flex justify-content-end">
      <button
        class="btn btn-outline-secondary"
        data-testid="planning-duration-modal-close-button"
        (click)="closeModal()"
        [disabled]="isSaving || isBulkProcessing || isBulkCommentPosting"
      >
        {{ "durationModal.close" | translate }}
      </button>
    </div>
  </div>
</app-modal-container>
